import Vue from 'vue'

import Store from '../store/store'
const commonJs = {

}

/**
 * 已知角度及临边，求对边
 */
commonJs.getXYcoordinate = function (x, angle) {
  var len = x * Math.tan(angle * Math.PI / 180)
  return len
}
/**
 * 已知正切值求度数
 */
commonJs.getInclinationAngle = function (tanChan) {
  return Math.atan(tanChan) / (Math.PI / 180)
}

/**
 * 获取根据度数直角边，通过余弦值求斜边
 */
commonJs.getByCosCoor = function (x, angle) {
  return x / Math.cos(angle * Math.PI / 180)
}

commonJs.getAngleBy2Point = function (x1, y1, x2, y2) {
  return this.getInclinationAngle((y2 - y1) / (x1 - x2))
}

/**
 * 格式化单位
 */
commonJs.getReData = function (data) {
  return data
}

/**
 * 获取根据度数，通过正切值求直角另一条边的长度（被除数的边）
 */
commonJs.getXYcoordinateDividend = function (x, angle) {
  var len = x * Math.tan(angle * Math.PI / 180)
  return len
}
/**
 * 获取根据度数，通过正切值求直角另一条边的长度（除数的边）
 */
commonJs.getXYcoordinateByDividend = function (x, angle) {
  var len = x / Math.tan(angle * Math.PI / 180)
  return len
}

/**
 * 将最大最小范围值与真实值作比较，大于最大取最大，小于最小取最小
 */
commonJs.getMinOrMaxVal = function (val, min, max) {
  if (val < min) {
    return min
  } else if (val > max) {
    return max
  } else {
    return val
  }
}

/**
 * 根据单位换算值，需要转换成厘米的时候toCmFlag传入true
 */
commonJs.changeUnit = function (value, unit, toCmFlag) {
  var temp
  var n = parseFloat(value)
  var liCom = 1 / 16
  if (isNaN(n)) {
    return value
  }
  if (toCmFlag) {
    switch (unit) {
      case 'T_METRE_M':
        temp = value * 100
        break
      case 'T_MILLIMETER_MM':
        temp = value / 10
        break
      case 'T_FEET_DECIMAL':
        temp = value * 2.54 * 12
        break
      case 'T_INCH_DECIMAL':
        temp = value * 2.54
        break
      case 'T_FEET_FRACTION':
        temp = feetTemp(value)
        break
      case 'T_INCH_FRACTION':
        temp = inchTemp(value)
        break
    }
  } else {
    switch (unit) {
      case 'T_METRE_M':
        temp = getToFixed((value / 100), 3)
        break
      case 'T_MILLIMETER_MM':
        temp = getToFixed((value * 10), 0)
        break
      case 'T_FEET_DECIMAL':
        temp = getToFixed((value / 2.54 / 12), 2)
        break
      case 'T_INCH_DECIMAL':
        temp = getToFixed((value / 2.54), 2)
        break
      case 'T_FEET_FRACTION':
        // let ft = value / 2.54 / 12
        // if (ft === Store.state.limitData) {
        //   temp = 0 + "'" + ' ' + 0 + '-' + 0 + '/' + 100 + '"'
        //   break
        // }
        // let ftZ = Math.floor(ft)
        // let ftycp = (ft - ftZ) * 12
        // let ycz = Math.floor(ftycp)
        // let fraction = ftycp - ycz
        // let resArr = this.calsFs(fraction)
        // let resArr0 = parseInt(resArr[0])
        // let resArr1 = parseInt(resArr[1])
        // let resArrCalsFs = this.calsFs(resArr0 / resArr1)
        // resArr0 = resArrCalsFs[0]
        // resArr1 = resArrCalsFs[1]
        // let inchsTemp = ftZ + "'" + ' ' + ycz + '-' + resArr0 + '/' + resArr1 + '"'
        // if (resArr0 === 0) {
        //   temp = 0 + "'" + ' ' + 0 + '-' + 0 + '/' + 100 + '"'
        // } else {
        //   temp = inchsTemp
        // }
        // break
        let ins = value / 2.54
        // let ins = Math.round(value / 2.54)
        if (ins <= Store.state.limitData) {
          temp = 0 + "'" + ' ' + 0 + '-' + 0 + '/' + 16 + '"'
          break
        }
        let ftZ = parseInt(ins / 12)
        let ycz = Math.floor((ins / 12 - ftZ) * 12)
        let xsz = (ins / 12 - ftZ) * 12 - ycz
        let resArr0 = Math.round(xsz / liCom)
        if (resArr0 === 16) {
          ycz++
          resArr0 = 0
          if (ycz === 12) {
            ftZ++
            ycz = 0
          }
        }
        let es = reductionTo(resArr0, 16)
        let inchsTemp = ftZ + "'" + ' ' + ycz + '-' + es[0] + '/' + es[1] + '"'
        temp = inchsTemp
        break
      case 'T_INCH_FRACTION':
        let feet = value / 2.54
        if (feet <= Store.state.limitData) {
          temp = 0 + ' ' + 0 + '/' + 16 + '"'
          break
        }
        let feetfractions = 16
        let feetfrain = Math.floor(feet)
        let feetnumerator = Math.round((feet - feetfrain) / (1 / feetfractions))
        let feetdenominator = feetfractions
        let feetsTemp = 0
        while ((feetnumerator % 2 === 0) && ((feetdenominator % 2 === 0))) {
          feetnumerator /= 2
          feetdenominator /= 2
        }
        if (feetnumerator === 1 && feetdenominator === 1) {
          feetfrain += 1
          feetnumerator = 0
        }
        if (feetfrain > 0) {
          feetsTemp = feetfrain
        } else {
          feetsTemp = ''
        }
        if (feetnumerator > 0) {
          if (feetfrain > 0) {
            feetsTemp += ' '
          }
          feetsTemp += feetnumerator.toFixed(0) + '/' + feetdenominator.toFixed(0) + '"'
        } else {
          feetsTemp += '"'
        }
        if (feetsTemp === '"') {
          temp = 0.00
        } else {
          temp = feetsTemp
        }
        break
    }
  }
  return temp
}

function getToFixed (value, tip) {
  value = Number(value.toFixed(tip))
  value = value === 0 ? 0 : value
  return value.toFixed(tip)
}
/**
 * 将分数约分方法
 * m,n为正整数的分子和分母
 */
function reductionTo (m, n) {
  var arr = []
  if (!isInteger(m) || !isInteger(n)) {
    console.log('m和n必须为整数')
    return
  }
  var a = m
  var b = n
  if (a >= b) {
    a = m
    b = n
  } else {
    a = n
    b = m
  }
  if (m !== 1 && n !== 1) {
    for (var i = b; i >= 2; i--) {
      if (m % i === 0 && n % i === 0) {
        m = m / i
        n = n / i
      }
    }
  }
  arr[0] = m
  arr[1] = n
  return arr
}
// 判断一个数是否为整数
function isInteger (obj) {
  return obj % 1 === 0
}
// inch分数转cm
function inchTemp (value) {
  if (value * 1 === 0) {
    return 0
  }
  if (value.indexOf("'") > 0) {
    return ''
  }
  let inchFrain = value.split('"')[0].split(' ')
  if (inchFrain.length < 2) {
    return inchFrain[0] * 2.54
  }
  let inchFraction = inchFrain[1].split('/')
  let inchDecimal = inchFraction[0] / inchFraction[1] * 2.54
  return inchDecimal + inchFrain[0] * 2.54
}
// feet分数转cm
function feetTemp (value) {
  if (value * 1 === 0) {
    return 0
  }
  if (value.indexOf("'") === -1 || value.indexOf('-') === -1 || value.indexOf('/') === -1 || value.indexOf('"') === -1) {
    return ''
  }
  let feetFrain = value.split("'")
  let feetFraction = feetFrain[1].split('"')[0].split('-')
  let feetFrac = feetFraction[1].split('/')
  let feetFs = feetFraction[0].split(' ')
  let feetDecimal = feetFrain[0] * 1 + (feetFs[1] * 1 + feetFrac[0] / feetFrac[1]) / 12
  return feetDecimal * 2.54 * 12
}

commonJs.calsFs = function (m) {
  m = m * 100
  let n = 100
  let arr = []
  let a = m
  let b = n
  if (a >= b) {
    a = m
    b = n
  } else {
    a = n
    b = m
  }
  if (m !== 1 && n !== 1) {
    for (let i = b; i >= 2; i--) {
      if (m % i === 0 && n % i === 0) {
        m = m / i
        n = n / i
      }
    }
  }
  arr[0] = m
  arr[1] = n
  return arr
}

commonJs.changeUnitDraw = function (value, unit, toCmFlag) {
  let data = this.changeUnit(value, unit, toCmFlag)
  let unitT = this.changeUnit(unit)
  if (unitT === 'T_FEET_FRACTION') {
    return this.checkData(feetTemp(data)) ? '' : data
  } else if (unitT === 'T_INCH_FRACTION') {
    return this.checkData(inchTemp(data)) ? '' : data
  } else {
    return this.checkData(data) ? '' : data
  }
}
commonJs.checkData = function (data) {
  if (!Number(data)) {
    return true
  } else if (Number(data) === 0) {
    return true
  } else if (Number(data) < 0) {
    return true
  } else {
    return false
  }
}

commonJs.findLensInfo = function (modelData) {
  let selectedModelHCode = modelData.code
  let data
  let matchingLensID = []
  if (modelData.lensExchange) {
    matchingLensID = Vue.prototype.OptionLensList.find(
      item => item.code === selectedModelHCode
    ).lenses
    data = this.findLensDataByIdAndSize(modelData.standardLens, modelData.lcdSize)
  } else {
    matchingLensID = []
    data = this.findLensDataByHCode(selectedModelHCode)
  }
  return { 'matchingLensID': matchingLensID, 'selectedLensInfo': data }
}

commonJs.findLensDataByIdAndSize = function (id, size) {
  let jsonData = Vue.prototype.OptionLensSpec.find(item => (item.id === id && item.lcdSize === size))
  let data
  if (jsonData) {
    data = this.constuctLensData(jsonData)
  }
  return data
}

commonJs.findLensDataByHCode = function (code) {
  let jsonData = Vue.prototype.ProjectorLensSpec.find(item => item.code === code)
  let data
  if (jsonData) {
    data = this.constuctLensData(jsonData)
  }
  return data
}

commonJs.findCurrentDistInfo = function (lensData) {
  let value = lensData.lcd.distInfo.find(item => item.ratio === Store.state.aspectRatio)
  return value
}

// 已知对象的value, 返回其key值
commonJs.findKey = (obj, value, compare = (a, b) => a === b) => {
  if (!obj) {
    console.log('findKey error!')
  }
  return Object.keys(obj).find(k => compare(obj[k], value))
}
commonJs.constuctLensData = function (data) {
  let value = {}
  let infoArr = this.findInfoByRatio(data)
  let distInfo = this.createDistInfo(infoArr)
  value['code'] = data['code']
  value['id'] = data['id']
  value['url'] = data['url']
  value['fNum'] = data['fNum']
  value['focalLength'] = data['focalLength']
  value['dimension'] = data['dimension']
  value['zoomRatio'] = data['zoomRatio']
  value['throwRatio'] = data['throwRatio']
  value['lcdSize'] = data['lcdSize']
  value['name'] = data['name']
  value['discontinued'] = data['discontinued']
  value['mu'] = data['mu'] / 10
  value['up'] = data['up'] / 10
  value['fe'] = data['fe'] / 10
  value['lx'] = data['lx'] / 10
  value['lens2mptsHeight'] = data['lens2mptsHeight'] / 10
  value['mpts2wallBottomHeight'] = data['mpts2wallBottomHeight'] / 10
  if (data['weight']) {
    value['weight'] = data['weight'].substring(0, data['weight'].length - 1) / 1000
  }
  value['lcd'] = {
    'aspectRatio': data['aspectRatio'],
    'distInfo': distInfo,
    'lensShiftRange': {
      'v': {
        'min': Math.abs(data['lensShiftVMin']) < 1 ? data['lensShiftVMin'] : data['lensShiftVMin'] / 100,
        'max': Math.abs(data['lensShiftVMax']) < 1 ? data['lensShiftVMax'] : data['lensShiftVMax'] / 100
      },
      'h': {
        'min': Math.abs(data['lensShiftHMin']) < 1 ? data['lensShiftHMin'] : data['lensShiftHMin'] / 100,
        'max': Math.abs(data['lensShiftHMax']) < 1 ? data['lensShiftHMax'] : data['lensShiftHMax'] / 100
      },
      'hv': {
        'min': Math.abs(data['lensShiftHvMin']) < 1 ? data['lensShiftHvMin'] : data['lensShiftHvMin'] / 100,
        'max': Math.abs(data['lensShiftHvMax']) < 1 ? data['lensShiftHvMax'] : data['lensShiftHvMax'] / 100
      }
    }
  }
  return value
}
commonJs.findInfoByRatio = function (data) {
  if (!data) {
    console.log('findInfoByRatio error')
  }
  let keys = Object.keys(data)
  let num = this.findRatioNum(data)
  let info = []
  for (let i = 0; i < num; i++) {
    let infoData = {}
    keys.forEach((item) => {
      if (item.charAt(item.length - 1) === String(i + 1)) {
        infoData[item.substr(0, item.length - 1)] = data[item]
      }
    })
    info.push(infoData)
  }
  return info
}
commonJs.createDistInfo = function (data) {
  let distInfo = []
  for (let i = 0; i < data.length; i++) {
    let val = data[i]
    let distInfoVal = {}
    distInfoVal = {
      'ratio': val['ratio'],
      'throwRange': {
        'w': {
          'min': val['disWMin'],
          'max': val['disWMax']
        },
        't': {
          'min': val['disTMin'],
          'max': val['disTMax']
        }
      },
      'size2dist': {
        'w': {
          'a': val['s2dWa'],
          'b': val['s2dWb']
        },
        't': {
          'a': val['s2dTa'],
          'b': val['s2dTb']
        }
      },
      'dist2size': {
        'w': {
          'a': val['d2sWa'],
          'b': val['d2sWb']
        },
        't': {
          'a': val['d2sTa'],
          'b': val['d2sTb']
        }
      },
      'screenSize': {
        'w': {
          'min': val['sizeWMin'],
          'max': val['sizeWMax']
        },
        't': {
          'min': val['sizeTMin'],
          'max': val['sizeTMax']
        }
      },
      'v1b': {
        'w': {
          'a': val['v1bWa'],
          'b': val['v1bWb']
        }
      },
      'wv': {
        'wv1': val['wv1'],
        'wv2': val['wv2']
      },
      'tv': {
        'tv1': val['tv1'],
        'tv2': val['tv2']
      }

    }
    distInfo.push(distInfoVal)
  }
  return distInfo
}

commonJs.findRatioNum = function (data) {
  let keys = Object.keys(data)
  let arr = []
  keys.forEach((item) => {
    let val = item.charAt(item.length - 1)
    let num = val.match(/\d/g)
    if (num) {
      arr.push(num[0] * 1)
    }
  })
  let maxVal = Math.max.apply(Math, arr)
  return maxVal
}

commonJs.findSpecInfoByRatio = function (ratio, data) {
  let distInfo = data.lcd.distInfo.find(
    item => item.ratio === ratio
  )
  return distInfo
}

commonJs.getPjImgUrl = function (view, type, selectedLensData) {
  let pre = 'P2-'
  let suf = 'front'
  let ceiling = ''

  switch (type) {
    case 0:
      pre = 'P2-'
      break
    case 1:
      pre = 'P1-'
      break
    case 2:
      pre = 'P3-'
      break
    default:
      break
  }
  if (Store.state.selectedModelData.lensExchange && selectedLensData && selectedLensData.id) {
    if (selectedLensData.id.indexOf('LX') > -1) {
      if (selectedLensData.id.indexOf('LX04H') > -1) {
        pre = 'P4-'
      } else {
        pre = 'P3-'
      }
    }
  }

  switch (view) {
    case 'sideView':
      suf = 'side'
      break
    case 'frontView':
      suf = 'front'
      break
    case 'topView':
      suf = 'top'
      break
    default:
      break
  }
  if (pre === 'P4-') {
    if ((Store.state.position === 0 || Store.state.position === 1 || Store.state.position === 4) && suf === 'front') {
      ceiling = '_down'
    }
    if (suf === 'top' || suf === 'side') {
      ceiling = '_' + Store.state.position
    }
    return process.env.BASE_URL + 'img/' + pre + suf + ceiling + '.svg'
  } else if (Store.state.position === 1) {
    ceiling = '_v'
  }
  // return process.env.BASE_URL + 'img/' + pre + suf + ceiling + '.png'
  return process.env.BASE_URL + 'img/' + pre + suf + ceiling + '.svg'
}

commonJs.toNumber = (val) => {
  var n = parseFloat(val)
  return isNaN(n) ? val : n
}

commonJs.getThrowRangeDiv = (length) => {
  let throwRangeDiv = []
  for (let i = 0; i < length; i++) {
    throwRangeDiv.push({
      id: i
    })
  }
  return throwRangeDiv
}

commonJs.isInPolygon = (checkPoint, polygonPoints) => {
  var counter = 0
  var i
  var xinters
  var p1, p2
  var pointCount = polygonPoints.length
  p1 = polygonPoints[0]

  for (i = 1; i <= pointCount; i++) {
    p2 = polygonPoints[i % pointCount]
    if (
      checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
    ) {
      if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
        if (p1[0] !== p2[0]) {
          xinters =
                      (checkPoint[0] - p1[0]) *
                          (p2[1] - p1[1]) /
                          (p2[0] - p1[0]) +
                      p1[1]
          if (p1[1] === p2[1] || checkPoint[1] <= xinters) {
            counter++
          }
        }
      }
    }
    p1 = p2
  }
  if (counter % 2 === 0) {
    return false
  } else {
    return true
  }
}

// 判断点p在当前多边形内部（包括边上）
commonJs.rayCasting = (p, poly) => {
  var px = p.x
  var py = p.y
  var flag = false
  for (var i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
    var sx = poly[i].x
    var sy = poly[i].y
    var tx = poly[j].x
    var ty = poly[j].y
    // 点与多边形顶点重合
    if ((sx === px && sy === py) || (tx === px && ty === py)) {
      return 'on'
    }
    // 判断线段两端点是否在射线两侧
    if ((sy < py && ty >= py) || (sy >= py && ty < py)) {
      // 线段上与射线 Y 坐标相同的点的 X 坐标
      var x = sx + (py - sy) * (tx - sx) / (ty - sy)
      // 点在多边形的边上
      if (x === px) {
        return 'on'
      }
      // 射线穿过多边形的边界
      if (x > px) {
        flag = !flag
      }
    }
  }
  // 射线穿过多边形边界的次数为奇数时点在多边形内
  return flag ? 'in' : 'out'
}

commonJs.calcThrowRangeStyle = (width, range, value) => {
  let throwRangeWidth = width * (value.max - value.min) / (range)
  let throwRangeLeft = width * value.min / (range)
  return {
    width: throwRangeWidth + 'px',
    left: throwRangeLeft + 'px'
  }
}

commonJs.dataSort = (data, key) => {
  let tempArray = JSON.parse(JSON.stringify(data))
  return tempArray && tempArray.sort((obj1, obj2) => {
    return obj1.name.localeCompare(obj2[key])
  })
}

commonJs.findMatchingModelByConf = function (val) {
  let matchingModel = null
  matchingModel = Vue.prototype.ProjectorSpec.filter(
    item => {
      let key = 'c' + val
      return item[key]
    }
  )
  return matchingModel
}

commonJs.findMatchingModel = function (val) {
  let matchingModel = null
  matchingModel = Vue.prototype.ProjectorSpec.filter(
    item => {
      let cateVal = item.category
      switch (val) {
        case 0:
          return cateVal === 0 || cateVal === 1 || cateVal === 2
        case 1:
          return cateVal === 3 || cateVal === 4
        case 2:
          return cateVal === 6 || cateVal === 7
        case 3:
          return cateVal === 8
        case 4:
          return cateVal === 9
        case 5:
          return cateVal === 5
        default:
          break
      }
    }
  )
  return matchingModel
}

commonJs.checkRange = (value, min, max) => {
  if (value > max * 1) {
    value = max * 1
  } else if (value < min * 1) {
    value = min * 1
  }
  // return Number(value).toFixed(2)
  return value
}

commonJs.matchRange = function (target, max, min) {
  let result = true
  if (min && max === '' && target * 1 < min * 1) {
    result = false
  }
  if (max && min === '' && target * 1 > max * 1) {
    result = false
  }
  if (max && min && (target * 1 > Math.max(max, min) || target * 1 < Math.min(max, min))) {
    result = false
  }
  return result
}

commonJs.getBrightnessPJProperty = function () {
  let { selectedModelData, selectedLensData } = Store.state
  let property = { cc: 0, mu: 0, up: 0, pjheight: 0, pjwidth: 0, lx: 0 }
  let lensExchange = selectedModelData.lensExchange
  if (lensExchange) {
    let code = selectedModelData.code
    let lensId = selectedLensData.id
    for (let i = 0; i < Vue.prototype.Brightness.optionLens.length; i++) {
      if (Vue.prototype.Brightness.optionLens[i].code === code && Vue.prototype.Brightness.optionLens[i].lensId === lensId) {
        property.cc = Vue.prototype.Brightness.optionLens[i].cc / 10
        property.mu = Vue.prototype.Brightness.optionLens[i].mu / 10
        property.up = Vue.prototype.Brightness.optionLens[i].up / 10
        property.pjheight = Vue.prototype.Brightness.optionLens[i].pjheight / 10
        property.pjwidth = Vue.prototype.Brightness.optionLens[i].pjwidth / 10
        property.lx = Vue.prototype.Brightness.optionLens[i].lx / 10
      }
    }
  }
  return property
}

export default commonJs

export function getMatchingLensById (lenses, size) {
  const tempArray = []
  lenses.forEach(element => {
    Vue.prototype.OptionLensSpec.forEach((item) => {
      if (item.id === element && item.lcdSize === size) {
        tempArray.push({
          id: item.id,
          name: item.name
        })
      }
    })
  })
  return tempArray
}
